export const SETTING_ATTRIBUTE_IDS = {
  DINING_PACKAGE_ENABLED: 1094,
  DINING_PACKAGE_REQUIRED: 1095,
  LOGIN_TO_HOST_ENABLED: 1096,
};

export const SETTING_GROUPS = () => [
  {
    NAME: 'All Restaurants (Free+, Basic, Pro, Premium)',
    ATTRIBUTE_IDS: [
      328,
      1088,
      21,
      25,
      23,
      1058,
      1069,
      SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_ENABLED,
      SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_REQUIRED,
      SETTING_ATTRIBUTE_IDS.LOGIN_TO_HOST_ENABLED,
      1070,
      1071,
      1072,
      1083,
      1085,
    ],
  },
  {
    NAME: 'Basic, Pro, Premium',
    ATTRIBUTE_IDS: [1052, 1055, 1045, 1051, 22, 335, 147, 1040],
  },
  {
    NAME: 'Pro, Premium',
    ATTRIBUTE_IDS: [1049, 1042, 1039, 1054, 1043, 1059, 1074, 1080, 1081],
  },
  {
    NAME: 'Premium Only',
    ATTRIBUTE_IDS: [330, 331, 1041, 1067, 1068],
  },
];

export const HIDEN_FROM_UI = [SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_REQUIRED];

export const DISABLED_SETTINGS = () => [
  {
    MERCHANT_PRODUCT: 4,
    ATTRIBUTE_IDS: [
      328,
      21,
      25,
      23,
      1052,
      1055,
      1045,
      1051,
      22,
      335,
      147,
      1040,
      1056,
      1049,
      1042,
      1039,
      1054,
      330,
      331,
      1041,
      1058,
      1059,
      1067,
      1068,
      1074,
      1080,
    ],
  },
  {
    MERCHANT_PRODUCT: 11,
    ATTRIBUTE_IDS: [
      1052,
      1055,
      1045,
      1051,
      22,
      335,
      147,
      1040,
      1056,
      1049,
      1042,
      1039,
      1054,
      330,
      331,
      1041,
      1058,
      1059,
      1067,
      1068,
      1074,
      1080,
    ],
  },
  {
    MERCHANT_PRODUCT: 1,
    ATTRIBUTE_IDS: [1049, 1042, 1039, 1054, 330, 331, 1041, 1058, 1059, 1067, 1068, 1074, 1080],
  },
  {
    MERCHANT_PRODUCT: 10,
    ATTRIBUTE_IDS: [330, 331, 1041, 1058, 1067, 1068],
  },
  {
    MERCHANT_PRODUCT: 8,
    ATTRIBUTE_IDS: [1058],
  },
  {
    MERCHANT_PRODUCT: 14,
    ATTRIBUTE_IDS: [SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_ENABLED]
  }
];



// WEBPACK FOOTER //
// ./src/app/merchants/settings/settings.constants.js